import type { JSX } from 'react';

import { MaintenanceBanner } from '../components/MaintenanceBanner';
import { useMaintenanceBanner } from '../hooks/maintenanceBanner';

export function MaintenanceBannerContainer(): JSX.Element | null {
	const maintenanceBannerMessage = useMaintenanceBanner();

	if (!maintenanceBannerMessage) return null;

	return <MaintenanceBanner message={maintenanceBannerMessage} />;
}
